import { useState, useEffect, useRef, useContext, useMemo } from "react";
import FilterSelect from "../../components/Filter/FilterSelect";
import "./PublicationAnalytics.scss";
import HorizontalBarChart from "../../components/d3Charts/HorizontalBarChart/HorizontalBarChart";
import MetricsCard from "../../components/MetricsCard/MetricsCard";
import Tabs from "../../components/Tabs/Tabs";
import Summary from "../../components/Summary/Summary";
import TimeSeries from "../../components/Timeseries/Timeseries";
import ReuseLicense from "../../components/ReuseLicense/ReuseLicense";
import OtherMetrics from "../../components/OtherMetrics/OtherMetrics";
import { useLocation } from "react-router-dom";
import HeaderNavigate from "../../components/headerNavigate/HeaderNavigate";
import AxiosService from "../../utils/AxiosService";
import { useCustomSearchParams } from "../../components/hooks/useCustomSearchParams";
import { SEARCH_PARAMS } from "../../utils/SearchParams";
import { KEY_NAME } from "../../utils/KeyName";
import { AppContext } from "../../context/AppContext";
import {
  faAlignCenter,
  faArrowDown19,
  faArrowDown91,
  faArrowDownAZ,
  faArrowDownZA,
} from "@fortawesome/free-solid-svg-icons";
import FilterBy from "../../components/Filter/FilterBy/FilterBy";
import { colorArray } from "../../utils/theme";
import AboutChartToggle from "../../components/AboutChartToggle/AboutChartToggle";
import EntityHeader from "../../components/dashboardLayout/EntityHeader/EntityHeader";
import DashboardInProgressModal, {
  isDashboardInProgress,
} from "../../components/DashboardInProgressModal/DashboardInProgressModal";

function publisherFilterOptions(name = KEY_NAME.FUNDER) {
  return [
    {
      label: `Top 10 ${name === KEY_NAME.FUNDER ? "publishers" : "funders"}`,
      value: "10",
    },
    {
      label: `Top 50 ${name === KEY_NAME.FUNDER ? "publishers" : "funders"}`,
      value: "50",
    },
  ];
}

const sortingList = [
  { label: "high to low", value: "high_to_low", icon: faArrowDown91 },
  { label: "low to high", value: "low_to_high", icon: faArrowDown19 },
  { label: "sort A-Z", value: "sort_A_Z", icon: faArrowDownAZ },
  { label: "sort Z-A", value: "sort_Z_A", icon: faArrowDownZA },
];

// const sortByIcons = {
//   high_to_low: faArrowDown91,
//   low_to_high: faArrowDown19,
//   sort_A_Z: faArrowDownAZ,
//   sort_Z_A: faArrowDownZA,
// };

const tabOptions = [
  "Summary",
  "Reuse License Type",
  "Time Series",
  // "Other Metrics",
];

const PublicationAnalytics = () => {
  const { entityName, selectedFilterBy, selectedFilterByLabel, metaInfo } =
    useContext(AppContext);
  const { get, set, setMultiple } = useCustomSearchParams();
  const [activeTab, setActiveTab] = useState(
    get(SEARCH_PARAMS.TAB) || "Summary",
  );
  const [verticalBarChartData, setVerticalBarChartData] = useState(null);
  const [horizontalChartData, setHorizontalChartData] = useState(null);
  const [shortName, setShortName] = useState(get(SEARCH_PARAMS.SHORT_NAME));
  const [sortBy, setSrotBy] = useState(sortingList[0]);
  const [filterdHorizontalChartData, setFilterdHorizontalChartData] =
    useState(null);
  const [isHorizontalChartLoading, setIsHorizontalChartLoading] =
    useState(true);
  const [isHorizontalChartError, setIsHorizontalChartError] = useState(false);

  const [publisher, setPublisher] = useState({
    type: "ALL", // ALL | CHORUS_ALL | CHORUS_MEMBER | NONE
    memberId: null,
  });

  const queryData = useMemo(() => {
    const filterSource =
      selectedFilterBy ?? get(SEARCH_PARAMS.FILTER_BY) ?? "ALL";

    const [filter, member] = filterSource.split(":");

    return {
      publisherFilter: filter,
      memberId: member ?? null,
    };
    // const filter =
    //   selectedFilterBy?.split(":")?.[0] ||
    //   get(SEARCH_PARAMS.FILTER_BY)?.split(":")?.[0] ||
    //   "ALL";

    // const member =
    //   selectedFilterBy?.split(":")?.[1] ||
    //   get(SEARCH_PARAMS.FILTER_BY)?.split(":")?.[1] ||
    //   "";

    // console.log("menmer id =>", selectedFilterBy, member);

    // return {
    //   publisherFilter: filter,
    //   memberId: member,
    // };
  }, [selectedFilterBy]);

  const [selectedPublisherNumber, setSelectedPublisherNumber] = useState(
    publisherFilterOptions(entityName).find(
      (item) => item.value === get(SEARCH_PARAMS.NUMBER_OF_PUBLISHER),
    ) || publisherFilterOptions(entityName)[0],
  );

  const hasFetched = useRef(false);
  // const location = useLocation();
  // const funderName = location.state?.funderName || "Funder";
  const [timeRange, setTimeRange] = useState("all");

  const [isMonthPickerOpen, setIsMonthPickerOpen] = useState(false);

  // const [monthRange, setMonthRange] = useState({
  //   from: { year: 2023, month: 0 },
  //   to: { year: 2024, month: 0 },
  // });

  // useEffect(() => {
  //   if (selectedFilterBy) {
  //     setQueryData((prev) => ({
  //       ...prev,
  //       publisherFilter: selectedFilterBy.split(":")?.[0],
  //       memberId: selectedFilterBy.split(":")?.[1],
  //     }));
  //   }
  // }, [selectedFilterBy]);

  useEffect(() => {
    if (timeRange === "custom") {
      setIsMonthPickerOpen(true);
    } else {
      setIsMonthPickerOpen(false);
    }
  }, [timeRange]);

  const axiosService = new AxiosService();

  const renderTabContent = () => {
    switch (activeTab) {
      case "Summary":
        return <Summary queryDataObj={queryData} />; //chartData={verticalBarChartData}
      case "Time Series":
        if (selectedFilterBy === "ALL" || !selectedFilterBy) {
          return <TimeSeries queryDataObj={queryData} />;
        } else {
          setActiveTab(tabOptions[0]);
          break;
        }

      case "Reuse License Type":
        return <ReuseLicense queryDataObj={queryData} />;
      case "Other Metrics":
        return <OtherMetrics />;
      default:
        return null;
    }
  };

  useEffect(() => {
    const params = {
      [SEARCH_PARAMS.NUMBER_OF_PUBLISHER]: selectedPublisherNumber.value,
      [SEARCH_PARAMS.TAB]: activeTab,
      [SEARCH_PARAMS.FILTER_BY]:
        selectedFilterBy || get(SEARCH_PARAMS.FILTER_BY),
      [SEARCH_PARAMS.FILTER_BY_NAME]: [
        "All funders",
        "All publishers",
      ].includes(selectedFilterByLabel)
        ? undefined
        : selectedFilterByLabel?.trim() || get(SEARCH_PARAMS.FILTER_BY_NAME),
    };

    setMultiple(params);
  }, [
    activeTab,
    selectedPublisherNumber,
    publisher,
    selectedFilterBy,
    selectedFilterByLabel,
  ]);

  useEffect(() => {
    if (hasFetched.current) return;
    // hasFetched.current = true;
    if (!entityName || !publisher) return;
    // const publisherQuery = buildPublisherQuery(publisher);

    setIsHorizontalChartLoading(true);
    setIsHorizontalChartError(false);

    switch (entityName) {
      case KEY_NAME.FUNDER:
        axiosService
          .getPublisherForHorizontalBarChart(sortBy, shortName)
          .then((response) => {
            setHorizontalChartData(response.data);
          })
          .catch((error) => {
            console.error("Error:", error);
            setHorizontalChartData(null);
            setIsHorizontalChartError(true);
          })
          .finally(() => {
            // setLoading(false); // STOP LOADER
            setIsHorizontalChartLoading(false);
          });

        break;
      case KEY_NAME.PUBLISHER:
        axiosService
          .getFundersForHorizontalBarChart(sortBy, shortName)
          .then((response) => {
            setHorizontalChartData(response.data);
          })
          .catch((error) => {
            console.error("Error:", error);
            setHorizontalChartData(null);
            setIsHorizontalChartError(true);
          })
          .finally(() => {
            // setLoading(false); // STOP LOADER
            setIsHorizontalChartLoading(false);
          });

        break;
      case KEY_NAME.INSTITUTION:
        axiosService
          .getFundersForHorizontalBarChart(sortBy, shortName)
          .then((response) => {
            setHorizontalChartData(response.data);
          })
          .catch((error) => {
            console.error("Error:", error);
            setHorizontalChartData(null);
            setIsHorizontalChartError(true);
          })
          .finally(() => {
            // setLoading(false); // STOP LOADER
            setIsHorizontalChartLoading(false);
          });
        break;

      default:
        break;
    }
  }, [entityName]);

  useEffect(() => {
    if (!horizontalChartData?.data) return;

    const limit = Number(selectedPublisherNumber?.value) || 0;

    const data = horizontalChartData.data.slice(0, limit);

    let sorted = [...data]; // copy array

    switch (sortBy.value) {
      case "high_to_low":
        sorted.sort((a, b) => b.workCount - a.workCount);
        break;

      case "low_to_high":
        sorted.sort((a, b) => a.workCount - b.workCount);
        break;

      case "sort_A_Z":
        sorted.sort((a, b) => a.name.localeCompare(b.name));
        break;

      case "sort_Z_A":
        sorted.sort((a, b) => b.name.localeCompare(a.name));
        break;

      default:
        break;
    }

    setFilterdHorizontalChartData(sorted);
  }, [sortBy, selectedPublisherNumber, horizontalChartData]);

  return (
    <div className="publication-analytics w-100">
      {/* <DashboardInProgressModal
        entityType={entityName}
        show={isDashboardInProgress(
          entityName,
          get(SEARCH_PARAMS.ENTITY_ID),
          get(SEARCH_PARAMS.SHORT_NAME),
        )}
      /> */}
      <HeaderNavigate showFilter={true} />

      <div className="bg-light text-start py-4 px-3 mb-4">
        <EntityHeader
          metaInfo={metaInfo}
          dashboardType={entityName}
          title={get(SEARCH_PARAMS.ENTITY_NAME)}
        />

        <FilterBy />
      </div>

      <div className="metrics-container text-start me-5">
        <h4 className="text-muted mb-4 sub-header">Key Metrics Data</h4>

        {metaInfo && (
          <div className="container px-0">
            <div className="row">
              <div className="col-12 col-sm-10">
                <MetricsCard
                  title="Publications to Date"
                  date={`From ${metaInfo.startDate} to present`}
                  // date="From 14 May 2015 to present"
                  value={metaInfo?.total?.toLocaleString("en-US")}
                  change={
                    selectedFilterBy === "ALL"
                      ? `${
                          metaInfo.percentIncrease > 0
                            ? "+" + metaInfo.percentIncrease.toFixed(2)
                            : metaInfo.percentIncrease
                        }%`
                      : "NA"
                  }
                  changeLabel="since last month"
                />
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Tabs */}
      <div className="tab-container">
        <Tabs
          tabs={
            selectedFilterBy === "ALL" || !selectedFilterBy
              ? tabOptions
              : ["Summary", "Reuse License Type"]
          }
          active={activeTab}
          onChange={setActiveTab}
        />
      </div>
      <div className="tab-content">{renderTabContent()}</div>

      {(selectedFilterBy === "ALL" || !selectedFilterBy) && (
        <div className="publishers-block">
          <div className="publishers-title">
            <h3 className="text-muted mb-4 sub-header">
              {entityName === KEY_NAME.FUNDER ? "Publishers" : "Funders"}
            </h3>
          </div>

          <div className="position-relative">
            <div className="top-funder-deopdown" style={{ zIndex: 100 }}>
              <div className="top-entity-dropdown">
                <FilterSelect
                  label=""
                  icon={faAlignCenter}
                  width="full"
                  value={selectedPublisherNumber?.label}
                  options={publisherFilterOptions(entityName)}
                  onChange={(value) => {
                    setSelectedPublisherNumber(value);
                  }}
                />
              </div>
              <div className="publicaion-analytics-sort-dropdown">
                <FilterSelect
                  label=""
                  icon={sortBy.icon}
                  width="full"
                  value={sortBy?.label}
                  options={sortingList}
                  onChange={(value) => {
                    setSrotBy(value);
                    // setSelectedPublisherNumber(value);
                  }}
                />
              </div>
            </div>

            {/* D3 Horizontal Bar Chart */}
            <div className="participants-chart">
              <HorizontalBarChart
                chartData={filterdHorizontalChartData}
                // chartData={horizontalChartData?.data?.slice(
                //   0,
                //   +selectedPublisherNumber?.value,
                // )}
                chartConfig={horizontalChartData?.config}
                title={`Top ${selectedPublisherNumber?.value} ${shortName} Publications Tracked by CHORUS`}
                notes={`Graph represents publications reporting on funded research by all funders. Funders are presented independent of their relationship to their parents. Asterisk denotes CHORUS ${entityName === KEY_NAME.FUNDER ? "Publisher Members." : "Funder Participants."} Hover over colored bars to see the full name of the funder.`}
                selectedNumberOfItem={selectedPublisherNumber?.value}
                colorArray={colorArray}
                isHorizontalChartLoading={isHorizontalChartLoading}
                hasError={isHorizontalChartError}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PublicationAnalytics;
